import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { CloudArrowUp, ListChecks } from '@phosphor-icons/react';
import { ClipboardPlus } from '../../../components/icons';
import { getChartStatusForTransmission } from './chartStatus';

export const CLICK_TO_VIEW_PATIENT_CHART = 'Click here to view Patient Chart';

const PATIENT_INFO_STATUS_KEYS = new Set([
  'task_created',
  'task_after_chart_creation_success',
  'routed_to_sftp',
  'sftp_fallback_delivered',
  'sftp_category_in_progress',
  'sftp_category_retryable',
  'sftp_category_delivered',
  'sftp_category_failed',
]);

const iconStyle = {
  marginRight: 4,
};

const buildIconNode = (statusKey, hasLink, statusIconNode) => {
  if (statusKey === 'routed_to_sftp' || statusKey === 'sftp_fallback_delivered') {
    return <CloudArrowUp size={18} color="orange" style={iconStyle} />;
  }
  if (statusKey.startsWith('sftp_category_')) return statusIconNode;
  if (!hasLink) return null;

  switch (statusKey) {
    case 'task_created':
      return <ListChecks size={18} color="#52c41a" style={iconStyle} />;
    case 'task_after_chart_creation_success':
      return <ClipboardPlus size={18} color="#52c41a" style={iconStyle} />;
    default:
      return null;
  }
};

export const openPatientChartLink = (event, link) => {
  if (!link) return;

  window.open(link, '_blank', 'noopener,noreferrer');
  event.stopPropagation();
  event.preventDefault();
};

export const getPatientInfoStatusConfig = (transmission = {}, options = {}) => {
  const status = getChartStatusForTransmission(transmission, options);

  if (!status || !PATIENT_INFO_STATUS_KEYS.has(status.statusKey)) {
    return null;
  }

  const iconNode = buildIconNode(status.statusKey, Boolean(status.link), status.iconNode);
  if (!iconNode) return null;

  return {
    ...status,
    iconNode,
  };
};

export const PatientInfoStatusIcon = ({ status }) => {
  if (!status || !status.iconNode) return null;

  const tooltipTitle = (
    <span>
      {status.message}
      {status.link && (
        <>
          <br />
          <br />
          {CLICK_TO_VIEW_PATIENT_CHART}
        </>
      )}
    </span>
  );

  const iconNode = status.link
    ? React.cloneElement(status.iconNode, {
      onClick: (event) => openPatientChartLink(event, status.link),
    })
    : status.iconNode;

  return (
    <Tooltip title={tooltipTitle}>
      {iconNode}
    </Tooltip>
  );
};

PatientInfoStatusIcon.defaultProps = {
  status: null,
};

PatientInfoStatusIcon.propTypes = {
  status: PropTypes.shape({
    message: PropTypes.string.isRequired,
    link: PropTypes.string,
    iconNode: PropTypes.node.isRequired,
  }),
};
